/* eslint-disable react/prop-types */
import React, { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import Dropzone, { useDropzone } from "react-dropzone";
import {
  Form,
  Modal,
  Row,
  Col,
  Button,
  Alert,
  Spinner,
  ListGroup,
} from "react-bootstrap";
import { Field, Formik } from "formik";
import * as yup from "yup";
import API from '../../Utility';
import MultiSelectTypeahead from "../../MultiSelectTypeahead/MultiSelectTypeahead";
import * as Yup from "yup";

export default function UploadUsersForm({ workflow, show, mode, user, onCancel, onSuccess }) {
  const [isLoading, setIsLoading] = useState(false);
  const [usersValue, setUsersValue] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [assignees, setAssignees] = useState([]);
  const [selectedAssignees, setSelectedAssignees] = useState([]);
  const [initialValues, setInitialValues] = useState({});
  const [isUserSubmitting, setIsUserSubmitting] = useState(false);

  function isValidDate(dateString) {
    // Regular expression to match YYYY-MM-DD format
    const regex = /^\d{4}-\d{2}-\d{2}$/;

    // Check if the date matches the regex
    if (!regex.test(dateString)) {
      return false;
    }

    // Split the date string into components
    const [year, month, day] = dateString.split('-').map(Number);

    // Validate year
    if (year < 2000 || year > 9999) {
      return false;
    }

    // Validate month
    if (month < 1 || month > 12) {
      return false;
    }

    // Validate day based on month and leap year
    const daysInMonth = [31, (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    if (day < 1 || day > daysInMonth[month - 1]) {
      return false;
    }

    return true;
  }

  const { project } = useParams(); // project needed for API
  useEffect(() => {
    async function initializeData() {
      mode === 'update' && user.assignees ? setSelectedAssignees(user.assignees) : setSelectedAssignees([]);
      mode === 'update' && user.user ? setSelectedUsers([user.user]) : setSelectedUsers([]);
      setIsLoading(true);
      const usersLookup = await API.get({
        url: `/admin/${project}/workflows/${workflow._id}/usersLookup?assigned=0&pageSize=1000`,
      });
      setUsersValue(usersLookup?.filteredResults.map(u => {
        return {
          name: u.displayName,
          ...u
        };
      }).filter(user => {
        return !user.isWorkflowUser;
      }));
      const assigneesLookup = await API.get({
        url: `/admin/${project}/workflows/${workflow._id}/assignees`,
      });
      setAssignees(assigneesLookup.map(u => {
        return {
          name: u.displayName,
          ...u
        };
      }));
      function formatDate(date) {
        var d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

        if (month.length < 2)
          month = '0' + month;
        if (day.length < 2)
          day = '0' + day;

        return [year, month, day].join('-');
      }
      let initVal = {};
      if (mode === 'update' && user?.user) {
        initVal.users = [user.user];
        setSelectedUsers([user.user]);
        if (user.startDate) {
          initVal.startDate = formatDate(user.startDate);
        }
        var assigneesSelected = [];
        if (workflow?.assigneeRoles?.[0] && user?.assignees?.[0] && assigneesLookup?.[0]) {
          workflow.assigneeRoles.map((role) => {
            user.assignees.map((selectAss) => {
              if (role._id === selectAss.assigneeRole) {
                let selectedAssigneeRole = selectAss;
                let selectedAssigneeUser = assigneesLookup.find(((user) => selectedAssigneeRole?.user === user._id));
                if (selectedAssigneeUser) {
                  assigneesSelected.push(selectedAssigneeRole);
                  initVal[`assignee_${role._id}`] = [
                    ...initVal[`assignee_${role._id}`] || [],
                    {
                      name: selectedAssigneeUser.displayName,
                      ...selectedAssigneeUser
                    }
                  ];
                }
              }
            });
          });
        }
        setSelectedAssignees(assigneesSelected);
      }
      setInitialValues(initVal);
      setIsLoading(false);
    }
    if (show) {
      initializeData();
    }
  }, [show]);

  // API Config
  const apiCallConfig = {
    url: `/admin/${project}/workflows/${workflow._id}/users/assignUsers`,
  };

  const [submitError, setSubmitError] = useState();
  // const [formValidated, setFormValidated] = useState(false);

  /**
   * This function is called internally when setFieldValue is called.
   * @param {*} values
   * @returns an error object
   */
  function validate(values) {
    const errors = {};
    // if (values.file === null || values.file === undefined) {
    //   errors.file = "Required";
    // }
    if (!values.startDate) {
      errors.startDate = "Start Date is required.";
    } else if(!isValidDate(values.startDate)) {
      errors.startDate = "Start Date is invalid.";
    }
    if (!values?.users?.[0]) {
      errors.users = "A minimum of one user is required";
    }
    if (workflow?.assigneeRoles?.[0]) {
      workflow.assigneeRoles.forEach(role => {
        if (!values[`assignee_${role._id}`]) {
          errors[`assignee_${role._id}`] = `Assignee ${role.name} must be assigned`;
        }
      });
    }
    return errors;
  }
  const submitForm = (values, { setSubmitting, resetForm }) => {
    setIsUserSubmitting(false);
    const callApi = async function() {
      try {
        setSubmitError();
        setSubmitting(true);
        apiCallConfig.data = {
          users: selectedUsers,
          assignees: selectedAssignees.map(({ _id, user, assigneeRole }) => {
            if (user?._id) {
              return {
                _id,
                assigneeRole,
                user: user._id
              };
            } else {
              return {
                _id,
                assigneeRole,
                user
              };
            }
          }),
          startDate: values.startDate
        };
        let res;
        if (mode === 'update' && user?.user) {
          apiCallConfig.url = `/admin/${project}/workflows/${workflow._id}/users/${user.user._id}`;
          res = await API.put(apiCallConfig);
        } else {
          res = await API.post(apiCallConfig);
        }
        setSubmitting(false);
        if (res?.response?.status && res.response.status !== 200) {
          setSubmitError(res?.response?.data);
        } else {
          setInitialValues({});
          resetForm();
          onSuccess(res);
        }
      } catch (err) {
        setSubmitting(false);
        if (!err.response) {
          setSubmitError(err && err.message);
        } else {
          setSubmitError(
            err &&
              err.response &&
              err.response.data &&
              err.response.data.message
          );
        }
      }
    };
    callApi();
  };

  const theForm = (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      scrollable={false}
      show={show}
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          {mode === 'update' ? 'Edit Assignment' : 'Assign Users'}
        </Modal.Title>
      </Modal.Header>

      { isLoading ?
        <Modal.Body>
          <Spinner animation="border" role="status"><span className="sr-only">Loading...</span></Spinner>
        </Modal.Body> :
        <Formik validate={validate} onSubmit={submitForm} initialValues={initialValues} enableReinitialize={true}>
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            values,
            touched,
            isValid,
            errors,
            submitCount,
            setFieldValue,
            setFieldError,
            setFieldTouched,
            isSubmitting,
            ...props
          }) => (
            <Form noValidate onSubmit={handleSubmit}>
              <Modal.Body>
                {mode === 'update' && user?.user ? (
                  <Form.Group>
                    {/* <Form.Label>User</Form.Label> */}
                    <h3>{user.user.displayName}</h3>
                  </Form.Group>
                ) : (
                  <Form.Group>
                    <Form.Label>User(s)</Form.Label>
                    <div className={errors?.users?.length > 0 ? 'is-invalid' : ''}>
                      <MultiSelectTypeahead
                        name='users'
                        displayName='Users'
                        items={usersValue}
                        multiple={true}
                        allowNewItems={false}
                        preventSelectAll={true}
                        dynamicHeight={true}
                        initialValues={selectedUsers}
                        placeholder="Users..."
                        className={`form-control`}
                        // className={`form-control ${touched.users && errors.users
                        //   ? "is-invalid"
                        //   : ""
                        // } ${touched.users && !errors.users
                        //   ? "is-valid"
                        //   : ""
                        // }`}
                        onChange={(value) => {
                          setFieldTouched('users', true);
                          setSelectedUsers(value);
                          if (Array.isArray(value)) {
                            setFieldValue('users', value.map((val) => val._id));
                          }
                        }}
                        onBlur={() => {
                          setFieldTouched('users', true);
                          if (!selectedUsers.length || selectedUsers.length === 0) {
                            setFieldError('users', 'A minimum of one user is required');
                          } else {
                            setFieldError('users', null);
                          }
                        }}
                        resetInputAfterSelectOrRemove={true}
                      />
                    </div>
                    {(isUserSubmitting || touched['users']) && errors?.[`users`]?.length > 0 && (
                      <div className='text-danger'>
                        {errors[`users`]}
                      </div>
                    )}
                  </Form.Group>
                )}
                <Form.Group>
                  <Form.Label>Start Date</Form.Label>
                  <Row>
                    <Col>
                      <Form.Control
                        type="date"
                        name="startDate"
                        defaultValue={initialValues.startDate ? initialValues.startDate : null}
                        placeholder="Start Date"
                        onChange={(e) => {
                          setFieldTouched('startDate', true);
                          setFieldValue(`startDate`, e.target.value);
                          let vals = { ...initialValues };
                          vals[`startDate`] = e.target.value;
                          // setInitialValues(vals);
                        }}
                        onBlur={() => {
                          setFieldTouched('startDate', true);
                          if (!values['startDate']) {
                            setFieldError('startDate', 'Start Date is required.');
                          } else if (!isValidDate(values['startDate'])) {
                            setFieldError('startDate', 'Start Date is invalid.";');
                          } else {
                            setFieldError('startDate', null);
                          }
                        }}
                        className={`form-control`}
                      ></Form.Control>
                      {(isUserSubmitting || touched['startDate']) && errors?.[`startDate`]?.length > 0 && (
                        <div className='text-danger'>
                          {errors[`startDate`]}
                        </div>
                      )}
                    </Col>
                  </Row>
                </Form.Group>
                <Form.Group>
                  <Form.Label>Assignees</Form.Label>
                  {
                    workflow?.assigneeRoles?.[0] && workflow.assigneeRoles.map(role => {
                      return (
                        <Form.Group key={role._id}>
                          <Col>
                            <Form.Label>{role.name}</Form.Label>
                          </Col>
                          <Col>
                            <MultiSelectTypeahead
                              name={`assignee_${role._id}`}
                              displayName={`${role.name} Assignees`}
                              items={assignees}
                              placeholder={`Select ${role.name}`}
                              defaultValue={values[`assignee_${role._id}`]?.[0]?.name ? values[`assignee_${role._id}`] : null}
                              className={`form-control`}
                              preventSelectAll={true}
                              onChange={(value) => {
                                let newSelectedAssignees = [
                                  ...selectedAssignees
                                ];
                                newSelectedAssignees = newSelectedAssignees.filter((selectedAssignee) => {
                                  return selectedAssignee.assigneeRole !== role._id;
                                });
                                if (value?.length !== 0) {
                                  if (Array.isArray(value)) {
                                    let mappedValue = value.map((val) => {
                                      return {
                                        assigneeRole: role._id,
                                        user: val
                                      };
                                    });
                                    newSelectedAssignees = [
                                      ...newSelectedAssignees,
                                      ...mappedValue
                                    ];
                                    setFieldValue(`assignee_${role._id}`, mappedValue);
                                    setFieldError(`assignee_${role._id}`, null);
                                    values[`assignee_${role._id}`] = mappedValue;
                                  }
                                } else {
                                  setFieldValue(`assignee_${role._id}`, null);
                                  setFieldError(`assignee_${role._id}`, `Please select ${role.name} user`);
                                  values[`assignee_${role._id}`] = null;
                                }
                                setSelectedAssignees(newSelectedAssignees);
                                setFieldTouched(`assignee_${role._id}`, true);
                              }}
                              onFocus={() => {
                                // setFieldTouched(`assignee_${role._id}`, true);
                              }}
                              onBlur={() => {
                                setFieldTouched(`assignee_${role._id}`, true);
                                let selectedAssigneeIndex = selectedAssignees.findIndex(selectedAssignee => {
                                  return selectedAssignee.assigneeRole === role._id;
                                });
                                if (selectedAssigneeIndex === -1) {
                                  setFieldError(`assignee_${role._id}`, `Please select ${role.name} user`);
                                } else {
                                  setFieldError(`assignee_${role._id}`, null);
                                }
                              }}
                              resetInputAfterSelectOrRemove={true}
                            />
                            {(isUserSubmitting || touched[`assignee_${role._id}`]) && errors?.[`assignee_${role._id}`]?.length > 0 && (
                              <div className='text-danger'>
                                {errors[`assignee_${role._id}`]}
                              </div>
                            )}
                          </Col>
                        </Form.Group>
                      );
                    })
                  }
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                {
                  submitError && submitError?.message &&
                <Row style={{flex: 1}}>
                  <Col><Alert variant={"danger"}>{submitError?.message}</Alert></Col>
                </Row>
                }
                {!isSubmitting ? (
                  <Row style={{ width: "100%", alignItems: "flex-end" }}>
                    <Col style={{ width: "100%", alignItems: "flex-end", textAlign: "right" }}>
                      <Button onClick={() => {
                        onCancel();
                        setIsUserSubmitting(false);
                        props.resetForm();
                        setSubmitError();
                      }} variant="outline-secondary" style={{marginRight: "10px"}}>
                      Cancel
                      </Button>
                      <Button variant="outline-primary" type="submit" disabled={isSubmitting} onClick={() => {
                        setIsUserSubmitting(true);
                      }}>
                      Save
                      </Button>
                    </Col>
                  </Row>
                ) : (
                  <Spinner animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                  </Spinner>
                )}
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      }
    </Modal>
  );
  return theForm;
}
